
interface MobileMenuButtonProps {
  toggleSidebar: () => void;
}

export const MobileMenuButton = ({ toggleSidebar }: MobileMenuButtonProps) => {
  return (
    <div className="md:hidden fixed top-4 left-4 z-20">
      <button 
        onClick={toggleSidebar}
        className="p-2 bg-[#1A1F2C] rounded-md text-white hover:bg-[#2A2F3C]"
        aria-label="Toggle navigation"
      >
        <span className="block w-5 h-0.5 bg-white mb-1"></span>
        <span className="block w-5 h-0.5 bg-white mb-1"></span>
        <span className="block w-5 h-0.5 bg-white"></span>
      </button>
    </div>
  );
};
